<template>
<div class="chapter">
<div class="inner_page">
<p style="font-style: italic; page-break-before: always; text-align: justify">La ventunenne Stephanie Stephenson è stata in una casa sicura per molti mesi insieme a tre guardie del corpo sexy. È l’unica testimone di un omicidio e loro l’hanno protetta da Santonio, il boss mafioso, che aveva giurato di vendicarsi se lei avesse osato testimoniare. Con le sue muscolose guardie del corpo è sempre stato tutto rigorosamente professionale e platonico. Ma ora il processo è finito e Stephanie è libera di andarsene.</p>
<p style="font-style: italic; text-align: justify">Però le tre guardie del corpo hanno altri piani per Stephanie... piani molto licenziosi.</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p class="first-in-scene" style="text-align: justify"><span class="first-scene-phrase"><span class="first-in-scene character-a">A</span>ltre storie di </span><span style="font-weight: bold">Jasmine Black </span>in italiano:</p>
<p style="font-weight: bold; text-align: justify">Serie Ménage:</p>
<ul style="text-align: justify"><li>Sedotta da tre motociclisti </li>
<li>Impegnata con tre miliardari </li>
<li>Impegnata con tre dottori </li>
<li>Cavalcata da tre cowboy </li></ul>
<p style="font-weight: bold; text-align: justify">Serie Taken:</p>
<ul style="text-align: justify"><li>Presa da due dottori </li>
<li>Sedotta da due biker </li>
<li>Presa da due miliardari </li>
<li>Sedotta da due boss </li>
<li>Presa da due personal trainers</li>
<li>Presa da due pompieri</li>
<li>Sedotta da due falegnami</li></ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?69eac037